import React, { Component } from 'react';

import './Checklist.scss';
import { Grid, Button } from '@material-ui/core';
import { withRouter } from "react-router-dom";
import List1 from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import no_policy from '../../../../../../Assets/Svg/no-policy.svg';


class IsEmpty extends Component {
  state = {
    anchorEl: null,
    createmenu: false,
    create_anchorEl: null,
    editable: (this.props.editable === undefined || this.props.editable) ? true : false,
  }

  // onCreate() {
  //   this.props.history.push(`${this.props.match.path}/create`);
  // }

  onCreate = (event) => {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
    });
  }

  onCreatemanuClose = () => {
    this.setState({
      createmenu: false,
      create_anchorEl: null,
    });
  }



  render() {
    return (
      <main className="content-outer-wrapper">

        <Grid container className="checklist-config-empty-state">
          <Grid item xs="12" className="noContentButton" >
            <Button className="btn btn-primary-md-blue" onClick={(e) => this.onCreate(e)}> create </Button>
          </Grid>
          <Grid item xs={12} align="center" >
            <img src={no_policy} className="no_policy" />
            <Grid item xs={12} className="noContentHeader" align="center">{this.props.header}</Grid>
            <Grid item xs={12} className="noContentText" align="center"> {this.props.text}</Grid>
          </Grid>
        </Grid>
        <Popover
          open={this.state.createmenu}
          anchorEl={this.state.create_anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={this.onCreatemanuClose}
          className="margin-top-8"
        >
          <Paper
            style={{
              width: 300,
              maxHeight: 400,
              overflowY: "auto",
            }}
          >
            <List1>
              {this.state.statusid !== 4 ? (
                <ListItem
                  button
                  className="padding-top-4 padding-bottom-4"
                  onClick={() => {
                    this.props.history.push(`${this.props.match.path}/create`);
                    this.onCreatemanuClose();
                  }}
                >

                  <ListItemText>
                    <p>Auto triggered (event based) </p>
                    <p>Checklists will be activated automatically on the selected events. Use for bulk actions.
                                 </p>

                  </ListItemText>

                  {/* <ListItemSecondaryAction>
                                <img src={newTab}></img>
                              </ListItemSecondaryAction> */}
                </ListItem>
              ) : null}


              <ListItem
                button
                onClick={() => {
                  this.props.history.push(`${this.props.match.path}/manualcreate`);
                  this.onCreatemanuClose();
                }}
                className="padding-top-4 padding-bottom-4"
              >
                <ListItemText>
                  <p>
                    Manual triggered (date based)
                                  </p>
                  <p>  Quickly assign one-time checklists with an option to choose from pre-created ones.
                                    </p>
                </ListItemText>
                {/* <ListItemIcon>
                  <img src={newTab}></img>
                </ListItemIcon> */}


              </ListItem>

            </List1>
          </Paper>
        </Popover>


      </main>
    );
  }
}

export default withRouter(IsEmpty);
